import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/date-cell.scss';

Component('tr-grid-date-cell', {
  mixins: [baseMixin],

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-date-picker-field:change': this.handleChange.bind(this),
      'tr-date-picker-field-list:opened': () => { this.editing = true; },
      'tr-date-picker-field-list:closed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.date-picker-field-result', this);
  },

  handleClick({ target }) {
    if (closest(target, '.date-picker-field-result', this)) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    if (!this.editor) return;

    this.editor.list.open();
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        if (this.value) {
          const nativeControl = this.editor
            .querySelector('.native-control-wrapper input');
          if (nativeControl) nativeControl.value = this.value;
        }

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });
        this.replaceChild(this.editor, this.firstElementChild);
      }
    });
  },

  handleChange(event) {
    this.value = event.detail;
    this.namespacedTrigger('cellValueChange', {
      detail: { value: event.detail },
      bubbles: true,
    });
  },
});
